







































































































































































import { Component, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import AnnoucementService from "@/services/Annoument.service";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import CoinService from "@/services/coins.service";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "../../models/porposal/porposalMembers.model";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Document from "../../models/document.model";
import ProposalUserReport from "@/models/porposal/porposalUserReport.model"
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import BudgetExpenseService from "@/services/budgetExpense.service";
import AnnoucementAreasService from "@/services/AnnoumentArea.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import ResearchCenterService from "@/services/researchCenter.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import DocumentComponentViewer from "@/components/document-component-view/documentComponentViewer.vue"
import UserService from '@/services/user.service';
import PorposalService from '@/services/porposal.service';
import PorposalDetail from '@/components/porposal-detail-component/detail.vue'
import { ProposalState } from '@/enums/ProposalState';
import { ProjectState } from '@/enums/projectState';
import { ProposalDetailTab } from '@/enums/proposalDetailTabsNumbers';
import fileService from "@/services/file.service";
import Axios from "axios";
import AnnoucementEvaluationType from '@/models/annoucement/annoucementEvaluationType.Model';
@Component({
  components: { DatePickerComponent, documentcomponent: DocumentComponent, ResearchCenterBasicInformationComponent, UserBasicInformationComponent, DocumentComponentViewer, PorposalDetail }
})
export default class PorposalDetailEvaluation extends GenericEdit<Porposal> {
  currentTab = 1;
  memberTypes: any = [];
  projectTypes: any = [];
  isCardModalActive: boolean = false;
  isComponentModalActive: boolean = false;
  areas: any = [];
  motivoDevolucion: string = null;
  fieldAreas: any = [];
  fieldAreasResearchLines: any = [];
  researchCenter: any = null;
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  CoinService = new CoinService();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  annoucementAreasService: AnnoucementAreasService = new AnnoucementAreasService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  userService: UserService = new UserService();
  proposalService: PorposalService = new PorposalService();
  researchCenters = [];
  counter: number;
  words: any;
  loading = false;
  dropFiles = [];
  Coins: [];
  file = null;
  projectEndFile = null;
  isLastReport: boolean = false;
  annoucementId: number | null = null;
  years: Array<number> = [];
  budgetExpenses = [];
  budgetItemCurrent = new PorposalBudgetItem();
  showAddPartida = false;
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;
  inProgressState: ProjectState = ProjectState.InProgress;
  totalBudgetFondocyt: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  showWarning = false;
  showModal: boolean = false;
  informeMessage: string = '';
  updateReports: number = 0;
  editReport: boolean = false;
  ReportId: number = 0;
  documentId: number = 0;
  projectEndFileId: number = 0;
  reportState: ProposalState = null;
  returnedReason: string = '';
  activeTab: number = 0;
  absolutePath: string = process.env.VUE_APP_BASE_URL;
  annoucementService: AnnoucementService = new AnnoucementService();
  evaluationTypes: Array<AnnoucementEvaluationType> = [];

  @Watch('isLastReport')
  onIsLastReport(value: boolean) {
    if (!value && this.projectEndFileId == 0) {
      this.projectEndFile = null;
    }
  }

  constructor() {
    super();
    this.controller = "Porposal";
    this.model = new Porposal();
    this.Coins = [];
    this.counter = 0;
    this.words = "";
    Quill.register("modules/imageDrop", ImageDrop);
  }
  
  async save(sendToIES:boolean = false) {
    if(!this.informeMessage) {
       this.operationFailed(
        "Debe agregar una descripción del informe!",
        5000
      );
      return;
    }

    if (!this.file) {
      this.operationFailed(
        "Favor subir un archivo de constancia de este cambio!",
        5000
      );
    } else {
      let message = this.editReport ? "Seguro de querer editar el informe seleccionado?" : "Seguro de haber seleccionado el informe correcto?";
      this.$buefy.dialog.confirm({
        title: "Advertencia",
        type: "is-warning",
        size: "is-medium",
        hasIcon: true,
        confirmText: "Sí",
        cancelText: "No",
        message: message,
      onConfirm: () => this.onConfirmSave(sendToIES)});
    }
  }

  get userCanAttachReport() {
    return (this.model.porposalMembers.some(x => x.userId == this.user.id)) ? true : false;
  }

  onUserReportSelected(data: any) {
    this.returnedReason = data.reason;
    this.reportState = data.state;
    this.ReportId = data.id;
    this.documentId = data.document.id;
    this.informeMessage = data.description;
    this.file = data.document;
    this.file.name = data.document.originalName;
    this.isLastReport = data.isLastResport;
    if (data.projectEndDocument) {
      this.projectEndFile = data.projectEndDocument;
      this.projectEndFile.name = data.projectEndDocument.originalName;
      this.projectEndFileId = data.projectEndDocument.id;
    }
    this.showModal = true;
    this.editReport = true;
  }

  async onConfirmSave(sendToIES:boolean) {
    
    this.showModal = false;
    this.loading = true;

    let doc = this.file.id ? this.file : await fileService.upload(this.file as File);
    /*
    if (doc.contentType == "application/octet-stream") {
      let extension = doc.originalName.match(/\.[0-9a-z]+$/i)[0];
      let indexOfSlash =doc.originalName.indexOf('/');
      doc.contentType = doc.contentType.substr(0 , indexOfSlash);  
      
    }
    */

    doc.refEntityKey = "Id";
    doc.refEntityName = "PorposalUserReport";

    let model = new ProposalUserReport();
    model.id = this.ReportId;
    model.document = doc;
    model.userId = this.user.id
    model.proposalId = this.model.id;
    model.description = this.informeMessage;

    if (this.isLastReport || this.projectEndFile) {
      let lastDoc = this.projectEndFile.id ? this.projectEndFile : await fileService.upload(this.projectEndFile as File);
      lastDoc.refEntityKey = "Id";
      lastDoc.refEntityName = "PorposalUserReport";
      model.isLastResport = this.isLastReport;
      model.projectEndDocument = lastDoc;
    } 

    if (this.editReport) {
      model.state = sendToIES ? ProposalState.EnviadoCI : this.reportState;
      if (model.state == ProposalState.EnviadoCI && this.model.hasFondocytNotification && this.isLastReport) {
        this.model.hasFondocytNotification = false;
      }

      model.document.refEntityValue = String(this.ReportId);
      model.document.id = this.documentId;
      if (model.projectEndDocument) {
        if (this.isLastReport) {
          model.projectEndDocument.refEntityValue = String(this.ReportId);
          model.projectEndDocument.id = this.projectEndFileId > 0 ? this.projectEndFileId : 0;
        } else {
          model.projectEndDocument.deleted = true;
          model.projectEndDocumentId = null;
        }
      }
      model.reason = this.returnedReason;
      this.proposalService
        .updateProposalUserReport(this.ReportId, model)
        .then(() => {
          let message = sendToIES ? 'Se ha editado y enviado su informe de manera exitosa' : 'Se ha editado su informe de manera exitosa';
          this.operationSuccess(message);
          this.cleanVariables();
          this.activeTab = ProposalDetailTab.REPORTES; 
        })
        .finally(() => {
          this.loading = false;
      });
    } else {
      model.state = sendToIES ? ProposalState.EnviadoCI : ProposalState.Creado;
      if (model.state == ProposalState.EnviadoCI && this.model.hasFondocytNotification && this.isLastReport) {
        this.model.hasFondocytNotification = false;
      }
      this.proposalService
        .addProposalUserReport(this.model.id, model)
        .then(() => {
          let message = sendToIES ? 'Se ha guardado y enviado su informe de manera exitosa' : 'Se ha guardado su informe de manera exitosa';
          this.operationSuccess(message);
          this.cleanVariables();
          this.activeTab = ProposalDetailTab.REPORTES;
        })
        .finally(() => {
          this.loading = false;
      });
    }
  }

  public async downloadFile() {
    
    let id = Number(this.$route.params.id);
    this.proposalService.getUserReportsQuantityByProposald(id).then(number => {
      Axios({
        url: `${process.env.VUE_APP_BASE_API_URL}api/Porposal/DownloadForm/${id}`,
        method: 'GET',
        responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `Informe #${number}.doc`);
          document.body.appendChild(fileLink);
          fileLink.click();
     });
    });
    
  }
  

  cleanVariables() {
    this.returnedReason = '';
    this.file = null;
    this.informeMessage = '';
    this.ReportId = 0;
    this.documentId = 0;
    this.projectEndFileId = 0;
    this.updateReports += 1;
    this.editReport = false;
    this.reportState = null;
    this.projectEndFile = null;
  }

  public onModalClose() {
    this.file = null;
    this.projectEndFile = null;
    this.editReport = false;
    this.isLastReport = false;
    this.informeMessage = "";
    this.reportState = null;
  }

  get showWasRejected() {
    if (this.model && this.model.proposalMovements.length > 0) {
      let lastMovement = this.model.proposalMovements[this.model.proposalMovements.length - 1];
      return lastMovement.estado == ProposalState.RechazadoCI ? true : false;
    }
    return false;
  }

  get getRazonRechazo() {
    return this.model.proposalMovements[this.model.proposalMovements.length - 1].razon;
  }

  protected async getData() {
    try {
      this.loading = true;
      let response = await this.repository.byId(this.id, this.include);
      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);
      this.model = response;
      this.annoucementId = this.model.annoucementId as number;
      this.modelInit = this.map<Porposal>(this.model);
      this.getEvaluators();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  getEvaluators() {
    this.annoucementService.getDetailAnnocement(this.model.annoucementId).then(response => {
        if (response) {
          this.evaluationTypes = response.annoucementEvaluationsTypes;
          if (this.model.proporsalUsersEvaluators && this.model.proporsalUsersEvaluators.length > 0) {
            this.evaluationTypes.forEach(evaluationType => {
              evaluationType.proporsalUsersEvaluators = this.model.proporsalUsersEvaluators.filter(x => x.evaluationTypeId == evaluationType.evaluationTypeId);
            });
          }
        }
      });
  }

  get user() {
    return this.$store.state.user;
  }
}
